import { Alert, AlertColor } from '@mui/material'
import { toast as toastify } from 'react-toastify'

const createAlert = (type: AlertColor, message: string) =>
  toastify(({ closeToast }) => (
    <Alert severity={type} onClose={() => closeToast()} sx={{ width: '100%' }}>
      {message}
    </Alert>
  ))

export const toast = {
  success: (message: string) => createAlert('success', message),
  error: (message: string) => createAlert('error', message),
  info: (message: string) => createAlert('info', message),
  warning: (message: string) => createAlert('warning', message),
}
